.container {
    background-color: var(--sidebar-primary);
}
